import axios from 'axios';
import {
  getAmicaleValidationAccessToken,
  clearAmicaleValidationSession,
} from '../app/amicales/auth/amicaleValidationStorage';

const BASE_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({ baseURL: BASE_URL });

// Attach the dedicated amicale-validation token (never the moteur token).
api.interceptors.request.use((config) => {
  const token = getAmicaleValidationAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Token invalid/expired — clear amicale session only.
      clearAmicaleValidationSession();
    }
    return Promise.reject(error);
  }
);

const ENDPOINT = '/amicales/validation';

const AmicaleValidationApi = {
  async login({ login, password, baseUrl }) {
    const res = await axios.post(`${BASE_URL}${ENDPOINT}/login`, {
      login,
      password,
      baseUrl: baseUrl || (typeof window !== 'undefined' ? window.location.origin : null),
    });
    return res.data;
  },

  async getMe() {
    const res = await api.get(`${ENDPOINT}/me`);
    return res.data;
  },

  async listReservations(params = {}) {
    const res = await api.get(`${ENDPOINT}/reservations`, { params });
    return res.data;
  },

  async validateReservation(reservationId, productType = 'hotel') {
    const res = await api.post(
      `${ENDPOINT}/reservations/${reservationId}/validate`,
      { productType }
    );
    return res.data;
  },

  async rejectReservation(reservationId, productType = 'hotel') {
    const res = await api.post(
      `${ENDPOINT}/reservations/${reservationId}/reject`,
      { productType }
    );
    return res.data;
  },

  async getBalance() {
    const res = await api.get(`${ENDPOINT}/balance`);
    return res.data;
  },
};

export default AmicaleValidationApi;
